import React, { useEffect, useRef, useState} from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './index.module.scss';
import { handleSearch, handleKeyDown, searchHouse } from './utils.jsx';
import InputGroup from 'react-bootstrap/InputGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';


const SearchHouseField = ({trackingSysId, setHouse, onDataReceived, setErrorData, setWarnData, setFormData}) => {
  const [inputValue, setInputValue] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [minLength, setMinLength] = useState(3);

  const intl = useIntl();
  
  const location = useLocation();
  useEffect(()=>{
    setOptions([]);
    typeaheadRef.current.clear();
    setInputValue(null);
  }, [location]);

  const typeaheadRef = useRef(null);
  const handleInputChange = (value) => { setInputValue(value); };
  const handleSearchSelected = () => {
    searchHouse(intl, trackingSysId, setHouse, inputValue, onDataReceived, setErrorData, setWarnData); 
    setMinLength(5)
    typeaheadRef.current.clear();
    setInputValue(null);
    setFormData(null)
  }

  return (
    <InputGroup className={styles.SearchHouseField}>
      <FormattedMessage id='searchHouseInputPlaceholder' defaultMessage="House...">{(msg) => (<AsyncTypeahead
        filterBy={() => true}
        useCache={false}
        id="searchHouseInput"
        isLoading={isLoading}
        labelKey={option => `${option.houseNum}\\${option.year} - CdRefGiant: ${option.cdRefGiant}`}
        inputProps={{maxLength: 100}}
        onChange={handleInputChange}   
        onKeyDown={(event) => {
          handleKeyDown(event, trackingSysId, setIsLoading, setOptions, setErrorData)
        }}
        onSearch={(houseNum) => {
          if (houseNum.length > minLength) {
            setTimeout(() => {
              handleSearch(trackingSysId, houseNum, setIsLoading, setOptions, setErrorData, setWarnData);
            }, 200); 
          }
        }}
        emptyLabel={<FormattedMessage id='noHouseFoundText' defaultMessage="No matches found."/>}
        searchText={<FormattedMessage id='houseSearchText' defaultMessage="Searching..."/>}
        options={options}
        placeholder={msg}
        promptText={msg}
        ref={typeaheadRef}
      />)}</FormattedMessage>
      <ToggleButton variant="primary" className={styles.SearchHouseButton} onClick={() => handleSearchSelected()} name="searchHouseButton" id="searchHouseButton">
        <FormattedMessage id='searchHouseButtonText' defaultMessage="Search"/>
      </ToggleButton>
    </InputGroup>
  )
}

export default SearchHouseField